import React, { useEffect, useState } from "react";
import Dashcard from "../Component/Dashcard";
import Paymenttable from "../Component/Paymenttable";
import "../Style/Pages/Locationpage.css";
import banner from "../Assets/location/Frame 2147226241.png";
import { useSelector } from "react-redux";
import { getWithTokenAPI, putWithTokenAPI } from "../Util/Api";
import { toast } from "react-toastify";
const Locationpage = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = auth.permission;
  const [radius, setRadius] = useState("");
  useEffect(() => {
    const fetchdrivermanagelist = async () => {
      try {
        const res = await getWithTokenAPI(token, `/admin/driver-radius `);
        setRadius(res?.driverRadiusKm?.driverRadiusKm);
      } catch {
        console.log("Error in fetching Limit Api");
      }
    };
    fetchdrivermanagelist();
  }, [token]);

  const handleUpdate = async () => {
    try {
      const response = await putWithTokenAPI(token, "/admin/driver-radius", {
        driverRadiusKm: Number(radius),
      });
      if (response?.data) {
        toast.success("Radius Updated Successfully");
      } else {
        toast.error("Radius Updation Failed");
      }
    } catch (err) {
      console.log("Error updating radius", err);
      toast.error(err);
    }
  };
  return (
    <div className="locationpage">
      <div className="lp1">
        <img src={banner}></img>
        <div className="radius">
          <span className="radiushead">Increase Kilometer of Driver</span>
          <div>
            <span className="radiusvalue">
              <input
                type="text"
                value={radius}
                onChange={(e) => setRadius(e.target.value)}
              ></input>
              km
            </span>
            <button type="text" onClick={handleUpdate}>
              Update
            </button>
          </div>
        </div>
      </div>
      <div className="lp2">
        <Dashcard page={"location"} />
      </div>
      <div className="lp3">
        <Paymenttable type={"city"} />
      </div>
    </div>
  );
};

export default Locationpage;
